/**
 * @author Owais Liaquat Ali
 * @datetime June, 24th 2023
 * @description: This class is for date time parsed.
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'uniqueChangeDetectorCharacter',
})
export class UniqueChangeDetectorCharacterPipe implements PipeTransform {
  private currentAlphabet = '';

  transform(name: string, index: number): boolean {
    index === 0 ? (this.currentAlphabet = '') : null;
    if (this.currentAlphabet === name?.toLowerCase()) return false;
    this.currentAlphabet = name?.toLowerCase();
    return true;
  }
}
